import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Experiments } from 'constants/optimizely'
import useExperiment from 'hooks/Optimizely/useExperiment'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import TextButton from 'LuxKit/Button/TextButton'

export function ViewOfferButton(
  {
    variant,
    textOnly = false,
  }:
  {
    variant: 'default' | 'condensed'
    textOnly?: boolean
  },
) {
  const { variation } = useExperiment(Experiments.croOfferCtaSeeDeal)
  if (textOnly) {
    if (variation === 'variant') {
      return <FormattedMessage
        id="NiSGACYS/p"
        defaultMessage="See deal"
        description="CTA text-only button label for the experiment variant on offer card listings"
      />
    } else {
      return <FormattedMessage
        id="fmQoCma2QV"
        defaultMessage="View offer"
        description="CTA text-only button label for viewing the full offer details on offer card listings"
      />
    }
  } else {
    if (variant === 'default' && variation === 'variant') {
      return <CSSBreakpoint min="desktop">
        <TextButton kind="primary" nonInteractable>
          <FormattedMessage
            id="A3F+cqNlja"
            defaultMessage="See deal"
            description="CTA button label for the experiment variant on desktop default offer cards"
          />
        </TextButton>
      </CSSBreakpoint>
    } else if (variant === 'default') {
      return <CSSBreakpoint min="desktop">
        <TextButton kind="primary" nonInteractable>
          <FormattedMessage
            id="QRWBrCWyrf"
            defaultMessage="View"
            description="Short CTA button label for viewing an offer on desktop in the default card variant"
          />
        </TextButton>
      </CSSBreakpoint>
    } else if (variant === 'condensed' && variation === 'variant') {
      return <TextButton kind="secondary" nonInteractable>
        <FormattedMessage id="LH+7bbY00e" defaultMessage="See" description="First word of 'See deal' button text. The word 'deal' follows on desktop only." /> <CSSBreakpoint as="span" min="desktop">&nbsp;<FormattedMessage id="r6UWF1ne0u" defaultMessage="deal" description="Second word of 'See deal' button text. Only visible on desktop screens." /></CSSBreakpoint>
      </TextButton>
    } else {
      return <TextButton kind="secondary" nonInteractable>
        <FormattedMessage id="f/gmxBuvRv" defaultMessage="View" description="First word of 'View offer' button text. The word 'offer' follows on desktop only." /> <CSSBreakpoint as="span" min="desktop">&nbsp;<FormattedMessage id="2SAs8XoaR5" defaultMessage="offer" description="Second word of 'View offer' button text. Only visible on desktop screens." /></CSSBreakpoint>
      </TextButton>
    }
  }
}
